"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BoxedButtonBase } from "./ButtonBase.js";
import { getButtonVariantProps } from "./createButtonVariant.js";
const SecondaryButton = forwardRef(function SecondaryButton2(props, ref) {
  return jsx(BoxedButtonBase, { ref, ...getButtonVariantProps("secondary", props) });
});
export {
  SecondaryButton
};
